'use client';
import { useEffect, useRef, useState } from 'react';
import { CardSlider, Slider, SliderControlButton } from '../Slider';
import { useGlobalStore } from '@/hooks/useGlobalStore';
import { isTimeFrame, mobileBreakPoint } from '@/utils/utils';
import useWindowSize from '@/utils/useScreenSize';

interface Props {
    content: any;
    data: {
        partyDateFolder: any;
        partyDetail: any;
        partyInformation: any;
    };
}
/** 适用于 pageDetail-PartyCard  */
const PartyCard = (props: Props) => {
    // const cardRef = useRef<HTMLDivElement>(null);
    const globalStore = useGlobalStore();
    const windowSize = useWindowSize();
    const isMobile = windowSize.width < mobileBreakPoint;
    const { partyDateFolder, partyInformation } = props.data;

    const [slideTo, setSlideTo] = useState(0);

    const themeColor =
        globalStore.globalSettingData?.masterColorCode?.targetItem?.themeColorCode?.value;
    const h2Color = partyInformation?.partyColorCode?.targetItem?.h2Color?.value;

    const partyThemeColor =
        partyInformation?.partyColorCode?.targetItem?.themeColorCode?.value || undefined;
    const partyH2Color = partyInformation?.partyColorCode?.targetItem?.h2Color?.value;

    const currentThemeColor = partyThemeColor ? partyThemeColor : themeColor;

    const cardThemeColor = {
        themeColor,
        h2Color,
        partyThemeColor,
        partyH2Color,
    };

    const partyCardList = partyDateFolder?.partyCardList;

    // const partyCardList = [...partyDateFolder.partyCardList].sort((a, b) => {
    //     if (
    //         a.partyCardState.targetItem.name === 'coming-soon' &&
    //         b.partyCardState.targetItem.name === 'active'
    //     ) {
    //         return 1;
    //     } else if (
    //         a.partyCardState.targetItem.name === 'active' &&
    //         b.partyCardState.targetItem.name === 'coming-soon'
    //     ) {
    //         return -1;
    //     } else {
    //         return 0;
    //     }
    // });

    useEffect(() => {
        const currentIndex = partyDateFolder?.partyCardList?.findIndex((party: any) => {
            return isTimeFrame(party?.partyDateTime?.dateValue, party?.partyEndDateTime?.dateValue);
        });
        setSlideTo(currentIndex < 0 ? 0 : currentIndex);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [partyCardList]);

    // console.log('setSlideTo-----', slideTo);

    if (partyCardList?.length < 3) {
        if (isMobile) {
            return (
                <Slider
                    slideTo={slideTo}
                    settings={{
                        loop: true,
                        // slidesPerGroup: 0,
                        roundLengths: true,
                        effect: 'coverflow',
                        slidesPerView: 1.2,
                        coverflowEffect: {
                            rotate: 0,
                            stretch: 50,
                            depth: 500,
                            modifier: 1,
                            slideShadows: false,
                        },
                        centeredSlides: true,
                        touchStartPreventDefault: false,
                        breakpoints: {
                            640: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                        },
                    }}
                    currentThemeColor={currentThemeColor}
                    className='w-full max-w-[1300px] xmd:my-5'
                >
                    {CardSlider(partyCardList, cardThemeColor)}
                    <SliderControlButton />
                </Slider>
            );
        }
        return (
            <div className='flex justify-center mb-10'>
                <Slider
                    slideTo={slideTo}
                    settings={{
                        touchStartPreventDefault: false,
                        breakpoints: {
                            640: {
                                slidesPerView: 2,
                            },
                            768: {
                                slidesPerView: 2,
                            },
                        },
                    }}
                    currentThemeColor={currentThemeColor}
                    className='w-full max-w-[1300px] xmd:my-5'
                >
                    {CardSlider(partyCardList, cardThemeColor)}
                    {partyCardList.length > 2 && <SliderControlButton />}
                </Slider>
            </div>
        );
    }

    return (
        <div className='flex justify-center mb-10'>
            <Slider
                slideTo={slideTo}
                settings={{
                    loop: true,
                    effect: 'coverflow',
                    slidesPerView: 1.2,
                    coverflowEffect: {
                        rotate: 0,
                        stretch: 50,
                        depth: 500,
                        modifier: 1,
                        slideShadows: false,
                    },
                    centeredSlidesBounds: true,
                    centeredSlides: true,
                    touchStartPreventDefault: false,
                    breakpoints: {
                        640: {
                            slidesPerView: 2,
                        },
                        768: {
                            slidesPerView: 2,
                        },
                    },
                }}
                currentThemeColor={currentThemeColor}
                className='w-full max-w-[1300px] xmd:my-5'
            >
                {CardSlider(partyCardList, cardThemeColor)}
                {partyCardList?.length > 2 && <SliderControlButton />}
            </Slider>
        </div>
    );
};

export default PartyCard;
